import axios from "axios"
import { isEmpty } from "lodash"
import {
  refreshClientCredentials,
  clearStoredAccessTokens,
} from "./auth"

let axiosAuthRequired = axios.create()
const maxRetries = 5
let currentRetry = 1

axiosAuthRequired.interceptors.response.use(
  response => {
    return response
  },
  error => {
    let errorStatus = error.request ? error.request.status : null

    // Rate limited
    if (errorStatus === 429) {
      return Promise.reject(error)
    }

    // Unauthorized, attempt to refresh token
    const refreshToken = window.localStorage.getItem("refresh_token")
    if (errorStatus === 401) {
      if (currentRetry++ <= maxRetries && !isEmpty(refreshToken)) {
        return refreshClientCredentials().then(response => {
          error.config.headers.Authorization =
            "Bearer " + response.data.access_token
          return axiosAuthRequired.request(error.config)
        })
      } else {
        // Tokens are no longer valid, so clear them from storage
        clearStoredAccessTokens()
      }
    }

    return Promise.reject(error)
  }
)

export default axiosAuthRequired



// WEBPACK FOOTER //
// ./src/api/axiosAuthRequired.js